import React from 'react';
import ImageMonoHtmlView from './ImageHtml';
import ImageMonoReactView from './Image';
const ImageMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ImageMonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(ImageMonoReactView, props);
};
ImageMonoView.displayName = 'ImageMonoView';
export default ImageMonoView;
